import type { ThemeManifest } from "../types";

export const manifest: ThemeManifest = {
  id: "default",
  displayName: "Default",
  description: "The original SkillFull design.",
  extends: null,
};
